export default __webpack_public_path__ + "media/images/car-delivery-6e016e1003c85156527ee8889abd6334.svg";